export default [
    {
        "data": [
            {
                "cross_section": "43827",
                "base": {
                    "sta_elev": {
                        "x": [
                            0,
                            6.2,
                            12.13,
                            14.7,
                            30.66,
                            46.05,
                            47.82,
                            51.74,
                            61.47,
                            65.16,
                            76.71,
                            88.99,
                            99.4,
                            106.39,
                            114.69,
                            129.9,
                            132.9,
                            145.13,
                            149.13,
                            150.08,
                            153.02,
                            185.71,
                            200.37,
                            203.08,
                            222.05,
                            232.43,
                            248,
                            254.85,
                            290.01,
                            302.29,
                            320,
                            335.98,
                            342.96,
                            349.47,
                            355.69,
                            360,
                            369.91,
                            382.88,
                            389.87,
                            395.86,
                            402.84,
                            408.73,
                            414.15,
                            438.05,
                            439.6,
                            442.86,
                            457.79,
                            460.7,
                            477.04,
                            479.87,
                            483.69,
                            500.81,
                            504.93,
                            511.73,
                            525.07,
                            534.11,
                            539.01,
                            546.56,
                            558.43,
                            564.73,
                            571.34,
                            579.98,
                            592.62,
                            604.76,
                            610.29,
                            619.7,
                            624.1,
                            644.79,
                            653.13,
                            657.34,
                            665.25,
                            675.54,
                            678.05,
                            686.8
                        ],
                        "y": [
                            159.07,
                            158.92,
                            158.78,
                            158.69,
                            158.25,
                            157.78,
                            157.71,
                            157.52,
                            157.06,
                            156.93,
                            156.66,
                            156.36,
                            156.09,
                            155.88,
                            155.76,
                            155.59,
                            155.51,
                            155.4,
                            155.37,
                            155.35,
                            155.31,
                            154.64,
                            154.21,
                            154.18,
                            153.97,
                            153.49,
                            152.865,
                            152.59,
                            152.35,
                            152.32,
                            152.2449,
                            152.22,
                            152.2,
                            152.18,
                            152.21,
                            152.235,
                            152.23,
                            152.16,
                            152.16,
                            152.3,
                            152.31,
                            152.4,
                            152.46,
                            152.63,
                            152.64,
                            152.67,
                            152.81,
                            152.81,
                            152.78,
                            152.8,
                            152.8,
                            152.84,
                            152.88,
                            152.98,
                            153.06,
                            153.15,
                            153.19,
                            153.22,
                            153.37,
                            155.1,
                            155.85,
                            156.89,
                            158.2,
                            158.78,
                            158.54,
                            159.09,
                            159.23,
                            157.92,
                            158.46,
                            157.9,
                            157.95,
                            157.96,
                            158.04,
                            158.3
                        ],
                        "title": "Ground (Floodway Run)"
                    }
                },
                "cmp": {
                    "sta_elev": {
                        "x": [
                            0,
                            6.2,
                            12.13,
                            14.7,
                            30.66,
                            46.05,
                            47.82,
                            51.74,
                            61.47,
                            65.16,
                            76.71,
                            88.99,
                            99.4,
                            106.39,
                            114.69,
                            129.9,
                            132.9,
                            145.13,
                            149.13,
                            150.08,
                            153.02,
                            185.71,
                            200.37,
                            203.08,
                            222.05,
                            232.43,
                            248,
                            254.85,
                            290.01,
                            302.29,
                            320,
                            335.98,
                            342.96,
                            349.47,
                            355.69,
                            360,
                            369.91,
                            382.88,
                            389.87,
                            395.86,
                            402.84,
                            408.73,
                            414.15,
                            438.05,
                            439.6,
                            442.86,
                            457.79,
                            460.7,
                            477.04,
                            479.87,
                            483.69,
                            500.81,
                            504.93,
                            511.73,
                            525.07,
                            534.11,
                            539.01,
                            546.56,
                            558.43,
                            564.73,
                            571.34,
                            579.98,
                            592.62,
                            604.76,
                            610.29,
                            619.7,
                            624.1,
                            644.79,
                            653.13,
                            657.34,
                            665.25,
                            675.54,
                            678.05,
                            686.8
                        ],
                        "y": [
                            159.07,
                            158.92,
                            158.78,
                            158.69,
                            158.25,
                            157.78,
                            157.71,
                            157.52,
                            157.06,
                            156.93,
                            156.66,
                            156.36,
                            156.09,
                            155.88,
                            155.76,
                            155.59,
                            155.51,
                            155.4,
                            155.4,
                            155.4,
                            155.4,
                            155.4,
                            155.4,
                            154.18,
                            153.97,
                            153.49,
                            152.865,
                            152.59,
                            152.35,
                            152.32,
                            152.2449,
                            152.22,
                            152.2,
                            152.18,
                            152.21,
                            152.235,
                            152.23,
                            152.16,
                            152.16,
                            152.3,
                            152.31,
                            152.4,
                            152.46,
                            152.63,
                            152.64,
                            152.67,
                            152.81,
                            152.81,
                            152.78,
                            152.8,
                            152.8,
                            152.84,
                            152.88,
                            152.98,
                            153.06,
                            153.15,
                            153.19,
                            153.22,
                            153.37,
                            155.1,
                            155.85,
                            156.89,
                            158.2,
                            158.78,
                            158.54,
                            159.09,
                            159.23,
                            157.92,
                            158.46,
                            157.9,
                            157.95,
                            157.96,
                            158.04,
                            158.3
                        ],
                        "title": "Ground (Floodway Run)"
                    },
                    "wsel": {
                        "x": [
                            177.93,
                            370.78499999999997,
                            563.64
                        ],
                        "y": [
                            154.8,
                            154.8,
                            154.8
                        ],
                        "title": "100yr WSEL (Floodway Run)"
                    },
                    "banks": {
                        "x": [
                            624.1,
                            653.13
                        ],
                        "y": [
                            159.23,
                            158.46
                        ],
                        "title": "Banks (Floodway Run)"
                    },
                    "ineffs": {
                        "x": [],
                        "y": [],
                        "title": "XS Ineff (Floodway Run)"
                    }
                }
            },
            {
                "cross_section": "43002",
                "base": {
                    "sta_elev": {
                        "x": [
                            4536.5,
                            4536.9,
                            4606.5,
                            4626.5,
                            4636.9,
                            4651.5,
                            4661.5,
                            4666.5,
                            4686.5,
                            4691.5,
                            4706.5,
                            4721.5,
                            4736.5,
                            4751.5,
                            4791.5,
                            4806.5,
                            4876.5,
                            4881.5,
                            4892.2,
                            4920.9,
                            4922.1,
                            4937.9,
                            4960.9,
                            4981.8,
                            4990.6,
                            4993.4,
                            4996.7,
                            4997.5,
                            4998.1,
                            4999.3,
                            5000,
                            5001.3,
                            5001.6,
                            5002,
                            5002.5,
                            5003.3,
                            5005.9,
                            5008.6,
                            5020.6,
                            5043,
                            5043.4,
                            5060.6,
                            5069.3,
                            5074,
                            5094.8,
                            5099.8,
                            5104.8,
                            5114.8,
                            5119.8,
                            5121.6,
                            5124.8,
                            5134.8,
                            5164.8,
                            5189.8,
                            5194.8,
                            5219.8,
                            5222.3,
                            5279.8,
                            5294.8,
                            5344.8,
                            5349.8,
                            5354.8,
                            5363.9
                        ],
                        "y": [
                            158.96,
                            158.95,
                            158.05,
                            157.61,
                            157.25,
                            156.75,
                            156.54,
                            156.35,
                            155.9,
                            155.68,
                            154.65,
                            154.16,
                            153.45,
                            152.91,
                            152.1,
                            152.03,
                            153.06,
                            152.98,
                            152.22,
                            150.17,
                            150.15,
                            150.46,
                            150.33,
                            149.93,
                            150.37,
                            149.67,
                            148.6,
                            148.4,
                            148.08,
                            147.93,
                            147.65,
                            147.66,
                            147.75,
                            147.94,
                            148.39,
                            148.63,
                            149.38,
                            150.28,
                            150.85,
                            151.36,
                            151.37,
                            151.91,
                            152.23,
                            152.4,
                            152.44,
                            152.78,
                            153.02,
                            153.29,
                            153.52,
                            153.67,
                            153.93,
                            154.46,
                            155.75,
                            157.24,
                            157.44,
                            158,
                            158.01,
                            158.3,
                            158.61,
                            158.69,
                            158.76,
                            158.91,
                            159.03
                        ],
                        "title": "Ground (Floodway Run)"
                    }
                },
                "cmp": {
                    "sta_elev": {
                        "x": [
                            4536.4,
                            4536.9,
                            4606.5,
                            4626.5,
                            4636.9,
                            4651.5,
                            4661.5,
                            4666.5,
                            4686.5,
                            4691.5,
                            4706.5,
                            4721.5,
                            4736.5,
                            4751.5,
                            4791.5,
                            4806.5,
                            4876.5,
                            4881.5,
                            4892.2,
                            4920.9,
                            4922.1,
                            4937.9,
                            4960.9,
                            4981.8,
                            4990.6,
                            4993.4,
                            4996.7,
                            4997.5,
                            4998.1,
                            4999.3,
                            5000,
                            5001.3,
                            5001.6,
                            5002,
                            5002.5,
                            5003.3,
                            5005.9,
                            5008.6,
                            5020.6,
                            5043,
                            5043.4,
                            5060.6,
                            5069.3,
                            5074,
                            5094.8,
                            5099.8,
                            5104.8,
                            5114.8,
                            5119.8,
                            5121.6,
                            5124.8,
                            5134.8,
                            5164.8,
                            5189.8,
                            5194.8,
                            5219.8,
                            5222.3,
                            5279.8,
                            5294.8,
                            5344.8,
                            5349.8,
                            5354.8,
                            5363.9
                        ],
                        "y": [
                            158.96,
                            158.95,
                            158.05,
                            157.61,
                            157.25,
                            156.75,
                            156.54,
                            156.35,
                            155.9,
                            155.68,
                            154.65,
                            154.16,
                            153.45,
                            152.91,
                            152.1,
                            152.03,
                            153.06,
                            152.98,
                            152.22,
                            150.17,
                            150.15,
                            150.46,
                            150.33,
                            149.93,
                            150.37,
                            149.67,
                            148.6,
                            148.4,
                            148.08,
                            147.93,
                            147.65,
                            147.66,
                            147.75,
                            147.94,
                            148.39,
                            148.63,
                            149.38,
                            150.28,
                            150.85,
                            151.36,
                            151.37,
                            151.91,
                            152.23,
                            152.4,
                            152.44,
                            152.78,
                            153.02,
                            153.29,
                            153.52,
                            153.67,
                            153.93,
                            154.46,
                            155.75,
                            157.24,
                            157.44,
                            158,
                            158.01,
                            158.3,
                            158.61,
                            158.69,
                            158.76,
                            158.91,
                            159.03
                        ],
                        "title": "Ground (Floodway Run)"
                    },
                    "wsel": {
                        "x": [
                            4723.08,
                            4925.405,
                            5127.73
                        ],
                        "y": [
                            154.09,
                            154.09,
                            154.09
                        ],
                        "title": "100yr WSEL (Floodway Run)"
                    },
                    "banks": {
                        "x": [
                            4990.6,
                            5008.6
                        ],
                        "y": [
                            150.37,
                            150.28
                        ],
                        "title": "Banks (Floodway Run)"
                    },
                    "ineffs": {
                        "x": [],
                        "y": [],
                        "title": "XS Ineff (Floodway Run)"
                    }
                }
            },
            {
                "cross_section": "42210",
                "base": {
                    "sta_elev": {
                        "x": [
                            4712.4,
                            4713.9,
                            4747.4,
                            4791.4,
                            4792.4,
                            4807.4,
                            4817.4,
                            4827.4,
                            4847.4,
                            4852.4,
                            4872.4,
                            4877.4,
                            4907.4,
                            4927.2,
                            4930.8,
                            4944.3,
                            4960,
                            4965,
                            4977.8,
                            4985.4,
                            4988.7,
                            4992.5,
                            4996,
                            4996.9,
                            4997.7,
                            4998.9,
                            4999.7,
                            5000.6,
                            5002.1,
                            5003.1,
                            5003.7,
                            5005.9,
                            5008.2,
                            5017.1,
                            5046.8,
                            5061.8,
                            5101.8,
                            5106.8,
                            5131.8,
                            5136.8,
                            5171.1,
                            5171.8,
                            5176.8,
                            5181.8,
                            5191.8,
                            5206.8,
                            5236.8,
                            5256.8,
                            5261.8,
                            5265.7,
                            5326.8,
                            5347.4,
                            5371.8,
                            5391.8,
                            5412.4
                        ],
                        "y": [
                            156.53,
                            156.47,
                            155.13,
                            154.71,
                            154.7,
                            154.34,
                            154.19,
                            153.74,
                            153.25,
                            152.9,
                            150.86,
                            150.57,
                            149.88,
                            148.63,
                            148.72,
                            148.55,
                            148.75,
                            149.65,
                            149.62,
                            149.85,
                            148.85,
                            147.09,
                            146.75,
                            146.68,
                            146.24,
                            146.03,
                            144.97,
                            145.53,
                            145.79,
                            146.63,
                            147.63,
                            147.88,
                            148.94,
                            148.74,
                            149.04,
                            149.32,
                            150.43,
                            151.01,
                            154.31,
                            154.37,
                            151.64,
                            151.58,
                            151.47,
                            151.48,
                            152.11,
                            152.84,
                            153.37,
                            153.62,
                            153.74,
                            153.86,
                            155.77,
                            156.18,
                            156.66,
                            156.84,
                            157.35
                        ],
                        "title": "Ground (Floodway Run)"
                    }
                },
                "cmp": {
                    "sta_elev": {
                        "x": [
                            4712.3,
                            4713.9,
                            4747.4,
                            4791.4,
                            4792.4,
                            4807.4,
                            4817.4,
                            4827.4,
                            4847.4,
                            4852.4,
                            4872.4,
                            4877.4,
                            4907.4,
                            4927.2,
                            4930.8,
                            4944.3,
                            4960,
                            4965,
                            4977.8,
                            4985.4,
                            4988.7,
                            4992.5,
                            4996,
                            4996.9,
                            4997.7,
                            4998.9,
                            4999.7,
                            5000.6,
                            5002.1,
                            5003.1,
                            5003.7,
                            5005.9,
                            5008.2,
                            5017.1,
                            5046.8,
                            5061.8,
                            5101.8,
                            5106.8,
                            5131.8,
                            5136.8,
                            5171.1,
                            5171.8,
                            5176.8,
                            5181.8,
                            5191.8,
                            5206.8,
                            5236.8,
                            5256.8,
                            5261.8,
                            5265.7,
                            5326.8,
                            5347.4,
                            5371.8,
                            5391.8,
                            5412.4
                        ],
                        "y": [
                            156.53,
                            156.47,
                            155.13,
                            154.71,
                            154.7,
                            154.34,
                            154.19,
                            153.74,
                            153.25,
                            152.9,
                            150.86,
                            150.57,
                            149.88,
                            148.63,
                            148.72,
                            148.55,
                            148.75,
                            149.65,
                            149.62,
                            149.85,
                            148.85,
                            147.09,
                            146.75,
                            146.68,
                            146.24,
                            146.03,
                            144.97,
                            145.53,
                            145.79,
                            146.63,
                            147.63,
                            147.88,
                            148.94,
                            148.74,
                            149.04,
                            149.32,
                            150.43,
                            151.01,
                            154.31,
                            154.37,
                            151.64,
                            151.58,
                            151.47,
                            151.48,
                            152.11,
                            152.84,
                            153.37,
                            153.62,
                            153.74,
                            153.86,
                            155.77,
                            156.18,
                            156.66,
                            156.84,
                            157.35
                        ],
                        "title": "Ground (Floodway Run)"
                    },
                    "wsel": {
                        "x": [
                            4826.11,
                            5044.9,
                            5263.69
                        ],
                        "y": [
                            153.8,
                            153.8,
                            153.8
                        ],
                        "title": "100yr WSEL (Floodway Run)"
                    },
                    "banks": {
                        "x": [
                            4985.4,
                            5008.2
                        ],
                        "y": [
                            149.85,
                            148.94
                        ],
                        "title": "Banks (Floodway Run)"
                    },
                    "ineffs": {
                        "x": [
                            4926,
                            4926,
                            null,
                            5074,
                            5074,
                            null
                        ],
                        "y": [
                            0,
                            153.28,
                            null,
                            0,
                            153.19,
                            null
                        ],
                        "title": "XS Ineff (Floodway Run)"
                    }
                }
            },
            {
                "cross_section": "42157",
                "base": {
                    "sta_elev": {
                        "x": [
                            4396.2,
                            4401.2,
                            4421.2,
                            4456.2,
                            4466.2,
                            4496.2,
                            4506.2,
                            4511.2,
                            4526.2,
                            4541.2,
                            4546.2,
                            4586.2,
                            4606.2,
                            4646.2,
                            4656.2,
                            4726.2,
                            4741.2,
                            4746.2,
                            4756.2,
                            4795.1,
                            4815.6,
                            4840.5,
                            4869.4,
                            4899.6,
                            4925.7,
                            4954.3,
                            4979.2,
                            4986.8,
                            4990.8,
                            4992.8,
                            4993.8,
                            4994.3,
                            4995.7,
                            4996.7,
                            4998.4,
                            4999.4,
                            5000.8,
                            5002.4,
                            5003.9,
                            5005,
                            5006,
                            5006.2,
                            5008.2,
                            5010.9,
                            5014.3,
                            5036.2,
                            5058.6,
                            5078.9,
                            5099,
                            5118.8,
                            5141.3,
                            5163.3,
                            5184.6,
                            5191.2,
                            5241.2,
                            5251.2,
                            5261.2,
                            5267.2,
                            5282.2,
                            5292.2,
                            5302.2,
                            5332.2,
                            5382.2,
                            5392.2,
                            5407.2,
                            5412.2,
                            5507.2,
                            5522.2,
                            5528.6,
                            5532.2,
                            5537.2,
                            5552.2,
                            5582.2,
                            5602.2,
                            5618
                        ],
                        "y": [
                            157.91,
                            157.97,
                            158.48,
                            158.33,
                            158.35,
                            157.71,
                            157.33,
                            157.3,
                            157.42,
                            157.79,
                            157.73,
                            156.53,
                            156.15,
                            156.06,
                            155.89,
                            155.83,
                            155.66,
                            155.39,
                            154.7,
                            151.61,
                            150.31,
                            150.75,
                            150.73,
                            149.67,
                            149.8,
                            149.02,
                            149.25,
                            149.03,
                            147.23,
                            146.34,
                            145.65,
                            145.22,
                            144.81,
                            144.97,
                            144.9,
                            144.72,
                            144.89,
                            145.07,
                            145.2,
                            145.3,
                            145.32,
                            145.66,
                            146.8,
                            149.21,
                            150.51,
                            150.86,
                            151.15,
                            151.3,
                            151.2,
                            150.59,
                            150.97,
                            151.39,
                            151.99,
                            153.05,
                            153.64,
                            153.64,
                            153.88,
                            153.95,
                            154.01,
                            153.98,
                            154.1,
                            154.81,
                            155.21,
                            155.41,
                            155.62,
                            155.63,
                            157.11,
                            157.83,
                            158.02,
                            158.13,
                            158.19,
                            158.23,
                            159.05,
                            159.28,
                            159.61
                        ],
                        "title": "Ground (Floodway Run)"
                    }
                },
                "cmp": {
                    "sta_elev": {
                        "x": [
                            4396.2,
                            4401.2,
                            4421.2,
                            4456.2,
                            4466.2,
                            4496.2,
                            4506.2,
                            4511.2,
                            4526.2,
                            4541.2,
                            4546.2,
                            4586.2,
                            4606.2,
                            4646.2,
                            4656.2,
                            4726.2,
                            4741.2,
                            4746.2,
                            4756.2,
                            4795.1,
                            4815.6,
                            4840.5,
                            4869.4,
                            4899.6,
                            4925.7,
                            4954.3,
                            4979.2,
                            4986.8,
                            4990.8,
                            4992.8,
                            4993.8,
                            4994.3,
                            4995.7,
                            4996.7,
                            4998.4,
                            4999.4,
                            5000.8,
                            5002.4,
                            5003.9,
                            5005,
                            5006,
                            5006.2,
                            5008.2,
                            5010.9,
                            5014.3,
                            5036.2,
                            5058.6,
                            5078.9,
                            5099,
                            5118.8,
                            5141.3,
                            5163.3,
                            5184.6,
                            5191.2,
                            5241.2,
                            5251.2,
                            5261.2,
                            5267.2,
                            5282.2,
                            5292.2,
                            5302.2,
                            5332.2,
                            5382.2,
                            5392.2,
                            5407.2,
                            5412.2,
                            5507.2,
                            5522.2,
                            5528.6,
                            5532.2,
                            5537.2,
                            5552.2,
                            5582.2,
                            5602.2,
                            5618
                        ],
                        "y": [
                            157.9,
                            157.97,
                            158.48,
                            158.33,
                            158.35,
                            157.71,
                            157.33,
                            157.3,
                            157.42,
                            157.79,
                            157.73,
                            156.53,
                            156.15,
                            156.06,
                            155.89,
                            155.83,
                            155.66,
                            155.39,
                            154.7,
                            151.61,
                            150.31,
                            150.75,
                            150.73,
                            149.67,
                            149.8,
                            149.02,
                            149.25,
                            149.03,
                            147.23,
                            146.34,
                            145.65,
                            145.22,
                            144.81,
                            144.97,
                            144.9,
                            144.72,
                            144.89,
                            145.07,
                            145.2,
                            145.3,
                            145.32,
                            145.66,
                            146.8,
                            149.21,
                            150.51,
                            150.86,
                            151.15,
                            151.3,
                            151.2,
                            150.59,
                            150.97,
                            151.39,
                            151.99,
                            153.05,
                            153.64,
                            153.64,
                            153.88,
                            153.95,
                            154.01,
                            153.98,
                            154.1,
                            154.81,
                            155.21,
                            155.41,
                            155.62,
                            155.63,
                            157.11,
                            157.83,
                            158.02,
                            158.13,
                            158.19,
                            158.23,
                            159.05,
                            159.28,
                            159.61
                        ],
                        "title": "Ground (Floodway Run)"
                    },
                    "wsel": {
                        "x": [
                            4767.69,
                            5012.52,
                            5257.35
                        ],
                        "y": [
                            153.79,
                            153.79,
                            153.79
                        ],
                        "title": "100yr WSEL (Floodway Run)"
                    },
                    "banks": {
                        "x": [
                            4986.8,
                            5014.3
                        ],
                        "y": [
                            149.03,
                            150.51
                        ],
                        "title": "Banks (Floodway Run)"
                    },
                    "ineffs": {
                        "x": [
                            4981,
                            4981,
                            null,
                            5018.8,
                            5018.8,
                            null
                        ],
                        "y": [
                            0,
                            153.28,
                            null,
                            0,
                            153.19,
                            null
                        ],
                        "title": "XS Ineff (Floodway Run)"
                    }
                }
            },
            {
                "cross_section": "41697",
                "base": {
                    "sta_elev": {
                        "x": [
                            4508.1,
                            4518.1,
                            4538.1,
                            4539,
                            4543.1,
                            4553.1,
                            4563.1,
                            4598.1,
                            4623.1,
                            4658.1,
                            4659.5,
                            4663.1,
                            4728.1,
                            4738.1,
                            4743.1,
                            4759.9,
                            4763.1,
                            4768.1,
                            4789.3,
                            4868.1,
                            4888.1,
                            4893.1,
                            4898.1,
                            4918.1,
                            4928.1,
                            4933.1,
                            4953.1,
                            4970.1,
                            4971.6,
                            4973.4,
                            4975.6,
                            4983.1,
                            4990.4,
                            5006.8,
                            5015.4,
                            5023.1,
                            5026.6,
                            5029,
                            5075.3,
                            5195.3,
                            5200.3,
                            5205.3,
                            5255.3,
                            5305.3,
                            5310.3,
                            5315.3,
                            5335.3,
                            5350.3,
                            5355.3,
                            5371.8,
                            5390.3,
                            5395.3,
                            5435.3,
                            5470.3,
                            5485.3,
                            5530.3,
                            5535.3,
                            5550.3,
                            5561.1,
                            5565.3,
                            5610.3,
                            5660.3,
                            5678.8
                        ],
                        "y": [
                            156.73,
                            156.88,
                            156.58,
                            156.56,
                            156.45,
                            156.05,
                            155.83,
                            155.49,
                            155.1,
                            154.87,
                            154.81,
                            154.65,
                            154.56,
                            154.67,
                            154.87,
                            155.92,
                            156.12,
                            156.28,
                            156.19,
                            155.86,
                            155.06,
                            154.68,
                            153.56,
                            151.5,
                            150.26,
                            149.94,
                            150.08,
                            148.33,
                            147.65,
                            147.48,
                            147.01,
                            146.87,
                            145.93,
                            145.51,
                            145.96,
                            145.23,
                            147.6,
                            148.05,
                            147.74,
                            148.01,
                            147.93,
                            147.92,
                            148.47,
                            149.74,
                            150.01,
                            150.34,
                            150.93,
                            151.2,
                            151.45,
                            152.5,
                            153.67,
                            153.86,
                            154.49,
                            155.43,
                            155.97,
                            156.92,
                            157.09,
                            157.37,
                            157.41,
                            157.43,
                            158.38,
                            159.39,
                            159.6
                        ],
                        "title": "Ground (Floodway Run)"
                    }
                },
                "cmp": {
                    "sta_elev": {
                        "x": [
                            4508.1,
                            4518.1,
                            4538.1,
                            4539,
                            4543.1,
                            4553.1,
                            4563.1,
                            4598.1,
                            4623.1,
                            4658.1,
                            4659.5,
                            4663.1,
                            4728.1,
                            4738.1,
                            4743.1,
                            4759.9,
                            4763.1,
                            4768.1,
                            4789.3,
                            4868.1,
                            4888.11,
                            4893.1,
                            4898.1,
                            4918.1,
                            4928.1,
                            4933.1,
                            4953.1,
                            4970.1,
                            4971.6,
                            4973.4,
                            4975.6,
                            4983.1,
                            4990.4,
                            5006.8,
                            5015.4,
                            5023.1,
                            5026.6,
                            5029,
                            5075.3,
                            5195.3,
                            5200.3,
                            5205.3,
                            5255.3,
                            5305.3,
                            5310.3,
                            5315.3,
                            5335.3,
                            5350.3,
                            5355.3,
                            5371.8,
                            5390.3,
                            5395.3,
                            5435.3,
                            5470.3,
                            5485.3,
                            5530.3,
                            5535.3,
                            5550.3,
                            5561.1,
                            5565.3,
                            5610.3,
                            5660.3,
                            5678.8
                        ],
                        "y": [
                            156.73,
                            156.88,
                            156.58,
                            156.56,
                            156.45,
                            156.05,
                            155.83,
                            155.49,
                            155.1,
                            154.87,
                            154.81,
                            154.65,
                            154.56,
                            154.67,
                            154.87,
                            155.92,
                            156.12,
                            156.28,
                            156.19,
                            155.86,
                            155.06,
                            154.68,
                            153.56,
                            151.5,
                            150.26,
                            149.94,
                            150.08,
                            148.33,
                            147.65,
                            147.48,
                            147.01,
                            146.87,
                            145.93,
                            145.51,
                            145.96,
                            145.23,
                            147.6,
                            148.05,
                            147.74,
                            148.01,
                            147.93,
                            147.92,
                            148.47,
                            149.74,
                            150.01,
                            150.34,
                            150.93,
                            151.2,
                            151.45,
                            152.5,
                            153.67,
                            153.86,
                            154.49,
                            155.43,
                            155.97,
                            156.92,
                            157.09,
                            157.37,
                            157.41,
                            157.43,
                            158.38,
                            159.39,
                            159.6
                        ],
                        "title": "Ground (Floodway Run)"
                    },
                    "wsel": {
                        "x": [
                            4932.03,
                            5121.15,
                            5310.27
                        ],
                        "y": [
                            250.01,
                            250.01,
                            250.01
                        ],
                        "title": "100yr WSEL (Floodway Run)"
                    },
                    "banks": {
                        "x": [
                            4970.1,
                            5029
                        ],
                        "y": [
                            148.33,
                            148.05
                        ],
                        "title": "Banks (Floodway Run)"
                    },
                    "ineffs": {
                        "x": [
                            4890,
                            4890,
                            null,
                            5110,
                            5110,
                            null
                        ],
                        "y": [
                            0,
                            149.1,
                            null,
                            0,
                            149.1,
                            null
                        ],
                        "title": "XS Ineff (Floodway Run)"
                    }
                }
            }
        ],
        "error_id": "SEC-01"
    },
    {
        "data": [
            {
                "cross_section": "43827",
                "diff": 16.62,
                "profile": "YR100"
            },
            {
                "cross_section": "41697",
                "diff": 696.61,
                "profile": "YR100"
            }
        ],
        "error_id": "SEC-02"
    },
    {
        "data": [
            {
                "cross_section": "42127 BR U"
            }
        ],
        "error_id": "SEC-ICS-01"
    }
]